import { type RepositoryAuthor } from "@prismicio/editor-fields"

import type { DocumentVersionStatus } from "../../../app/services/core"
import type { Filter, FilterType } from "./FilterDropdown"

export function getFilterType(filters: Filter[], filterType: FilterType) {
  return filters.filter((filter) => filter.type === filterType)
}

export function getFilterTypeStatus(filters: Filter[]) {
  return filters.filter(isDocumentVersionStatusFilter)
}

export function getAuthorDisplayName(author: RepositoryAuthor) {
  const { firstname, lastname } = author

  // If both firstname and lastname are empty, return the author id
  if (!firstname && !lastname) return author.id

  // If one of the firstname or lastname is empty, return the other
  if (!firstname && lastname) return lastname
  if (!lastname && firstname) return firstname

  // If both firstname and lastname are not empty, return the full name
  if (firstname && lastname) return `${firstname} ${lastname}`

  return ""
}

function isDocumentVersionStatusFilter(
  filter: Filter,
): filter is Filter<DocumentVersionStatus> {
  return filter.type === "status"
}
